import React from "react";
import { imgPath } from "../feature/core";
import { ScrollImages } from "./anim/ScrollImages";
import Img from "./basic/Img";

const baseClName = "ele-board";

function EleBoard() {
    return (
        <div className={baseClName}>
            <ScrollImages
                images={[
                    <Img fileName={"ele_board_text"} />,
                    <Img fileName={"ele_board_text"} />,
                ]}
                className={`${baseClName}-content`}
            />
        </div>
    );
}

export default EleBoard;
